export default 'DD. MMM YYYY';
